import PropTypes from "prop-types"

export const CONTRIBUTOR = PropTypes.shape({
  id: PropTypes.string,
  country: PropTypes.string,
  currency: PropTypes.string,
  description: PropTypes.string,
  modelProviderId: PropTypes.string,
  assetClass: PropTypes.string,
  bloombergTicker: PropTypes.string,
  classification: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  notHeld: PropTypes.string,
  economicExposure: PropTypes.number,
  basePercentEquity: PropTypes.number,
  positionPercentEquity: PropTypes.number,
  attribution: PropTypes.shape({
    summary: PropTypes.shape({
      factors: PropTypes.number,
      specific: PropTypes.number,
    }),
  }),
  total: PropTypes.number,
})

export const GROUP_ITEM = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isGroup: PropTypes.bool,
  isNotHeld: PropTypes.bool,
  contributors: PropTypes.arrayOf(CONTRIBUTOR),
  beta: PropTypes.object,
  performance: PropTypes.object,
  risk: PropTypes.object,
})

export const ITEM = PropTypes.shape({
  id: PropTypes.string,
  isAggregate: PropTypes.bool,
  isNotHeld: PropTypes.bool,
  percentEquity: PropTypes.number,
  beta: PropTypes.object,
  performance: PropTypes.object,
  risk: PropTypes.object,
})

export const COLUMN = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  headerLabel: PropTypes.string,
  path: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  outputFormat: PropTypes.oneOf(["percent", "number"]),
  isSticky: PropTypes.bool,
  editable: PropTypes.bool,
  sorted: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  allowAbsSort: PropTypes.bool,
  absSorted: PropTypes.bool,
  canAggregate: PropTypes.bool,
  formatter: PropTypes.func,
  makeClick: PropTypes.func,
  getter: PropTypes.func,
})

export const COLUMN_GROUP = PropTypes.shape({
  category: PropTypes.string,
  categoryTooltip: PropTypes.string,
  color: PropTypes.string,
  getter: PropTypes.func,
  columns: PropTypes.arrayOf(COLUMN),
})
